import { useContext } from 'react'
import { MemberComms } from 'contexts/MemberCommsProvider'

export const useMemberComms = () => {
  const context = useContext(MemberComms)
  if (!context) {
    throw new Error('useMemberComms must be used within MemberCommsProvider')
  }
  return context
}
